import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlideUsersRoutingModule } from './glide-users-routing.module';
import { MyProfileComponent } from './+users/my-profile/my-profile.component';
import { ChangePasswordDialogComponent } from './change-password-dialog/change-password-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { UserDetailsFormComponent } from '../shared/user-details-form/user-details-form.component';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
    imports: [
        CommonModule,
        GlideUsersRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatTooltipModule,
        MatIconModule,
        MatButtonModule,
        MatCardModule,
        MatDialogModule,
        UserDetailsFormComponent,
    ],
    declarations: [
        MyProfileComponent,
        ChangePasswordDialogComponent
    ],
    exports: [
        ChangePasswordDialogComponent
    ]
})
export class GlideUsersModule { }
